import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import kebabCase from 'lodash/kebabCase';
import get from 'lodash/get';
import { HOTELS_HOST } from 'config';

const pageTitle = (property) => `${property.name} | Qantas Hotels`;

const canonicalLink = (property) => `${HOTELS_HOST}/hotels/properties/${property.id}-${kebabCase(property.name)}`;

const meta = (property) => [
  { name: 'hotels-booking-stage', content: 'property-details' }, //used by qantas app
  { name: 'description', content: `Book Now & Earn Qantas Points on ${property.name}` },
  { name: 'og:site_name', content: 'Qantas Hotels' },
  { name: 'og:title', content: property.name },
  { name: 'og:url', content: canonicalLink(property) },
  { name: 'og:image', content: get(property, 'mainImage.urlLarge') },
  { name: 'og:latitude', content: property.latitude },
  { name: 'og:longitude', content: property.longitude },
  { name: 'og:street_address', content: get(property, 'address.streetAddress', []).join(', ') },
  { name: 'og:locality', content: get(property, 'address.suburb') },
  { name: 'og:region', content: get(property, 'address.state') },
  { name: 'og:country_name', content: get(property, 'address.country') },
];

const PropertyHelmet = ({ property }) => (
  <Helmet title={pageTitle(property)} meta={meta(property)} link={[{ rel: 'canonical', href: canonicalLink(property) }]} />
);

PropertyHelmet.propTypes = {
  property: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
};

export default PropertyHelmet;
